var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPhone = function SvgIconPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04305 9.53308C2.83045 9.53451 3.61301 9.40992 4.36105 9.16406C4.53674 9.1072 4.72425 9.09731 4.90495 9.13538C5.08565 9.17344 5.25323 9.25819 5.39104 9.3811L6.85305 10.4811C8.42681 9.69855 9.70208 8.42365 10.485 6.8501L9.41405 5.42615C9.27724 5.28975 9.18075 5.11817 9.13523 4.93042C9.0897 4.74267 9.09691 4.54597 9.15605 4.36206C9.40245 3.61241 9.52736 2.82817 9.52605 2.03906C9.52631 1.76252 9.63628 1.49742 9.83183 1.30188C10.0274 1.10634 10.2925 0.996359 10.569 0.996094H12.957C13.2336 0.996359 13.4987 1.10634 13.6943 1.30188C13.8898 1.49742 13.9998 1.76252 14 2.03906C13.9963 5.20912 12.7354 8.2483 10.4938 10.4899C8.25226 12.7314 5.2131 13.9924 2.04305 13.9961C1.76702 13.9964 1.50213 13.8873 1.30629 13.6927C1.11046 13.4982 0.999633 13.2341 0.998047 12.9581V10.5781C0.998047 10.301 1.10814 10.0352 1.30412 9.83923C1.50009 9.64326 1.76589 9.53308 2.04305 9.53308Z",
    fill: "#F27C25"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_phone.20b07009.svg";
export { ForwardRef as ReactComponent };